// Внешние (системные) браузерные уведомления — работают, даже если вкладка свёрнута
// или диспетчер переключился на другое окно. Требуют разрешения пользователя один раз.
export function requestNotificationPermission() {
  if (!('Notification' in window)) return;
  if (Notification.permission === 'default') {
    Notification.requestPermission().catch(() => {});
  }
}

// Показанные уведомления по метке (чат или наряд): прочитали чат или открыли наряд —
// закрываем их, чтобы в углу Windows не копились уже просмотренные
const shown = new Map<string, Notification[]>();

/**
 * tag — «direct:<id сантехника>», «channel:general», «order:<id>». Новое по той же метке
 * заменяет прежнее, а не ложится стопкой
 */
export function showBrowserNotification(title: string, body: string, tag?: string) {
  if (!('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  // Если вкладка и так открыта и видна — системное уведомление не нужно, оно и так на экране
  if (document.visibilityState === 'visible') return;
  try {
    const n = new Notification(title, { body, icon: '/favicon.svg', tag });
    if (tag) {
      shown.set(tag, [...(shown.get(tag) ?? []), n]);
      n.onclose = () => shown.set(tag, (shown.get(tag) ?? []).filter((x) => x !== n));
    }
  } catch {
    // некоторые окружения (например, без разрешений ОС) молча не показывают — не критично
  }
}

/** Закрыть показанные: по метке или все сразу (tag не задан) */
export function closeBrowserNotifications(tag?: string) {
  const tags = tag ? [tag] : [...shown.keys()];
  for (const t of tags) {
    shown.get(t)?.forEach((n) => n.close());
    shown.delete(t);
  }
}

/** Метка уведомления — как на сервере (notificationTag): чат или наряд */
export function notificationTag(n: { chatKey?: string | null; orderId?: string | null }): string | undefined {
  if (n.chatKey) return n.chatKey;
  if (n.orderId) return `order:${n.orderId}`;
  return undefined;
}
